import styled from "styled-components";

export const BreadcrumbContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 28px;
  padding-top: 8px;
  padding-bottom: 8px;
  gap: 32px;
`;

export const CustomBreadcrumbWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
